export default (dayOfMonth: Number) => {
    let returnVal = "Undefined";
    switch (dayOfMonth) {
        case 1: {
            returnVal = "1st"
            break;
        }
        case 2: {
            returnVal = "2nd"
            break;
        }
        case 3: {
            returnVal = "3rd"
            break;
        }
        case 4: {
            returnVal = "4th"
            break;
        }
        case 5: {
            returnVal = "5th"
            break;
        }
        case 6: {
            returnVal = "6th"
            break;
        }
        case 7: {
            returnVal = "7th"
            break;
        }
        case 8: {
            returnVal = "8th"
            break;
        }
        case 9: {
            returnVal = "9th"
            break;
        }
        case 10: {
            returnVal = "10th"
            break;
        }
        case 11: {
            returnVal = "11th"
            break;
        }
        case 12: {
            returnVal = "12th"
            break;
        }
        case 13: {
            returnVal = "13th"
            break;
        }
        case 14: {
            returnVal = "14th"
            break;
        }
        case 15: {
            returnVal = "15th"
            break;
        }
        case 16: {
            returnVal = "16th"
            break;
        }
        case 17: {
            returnVal = "17th"
            break;
        }
        case 18: {
            returnVal = "18th"
            break;
        }
        case 19: {
            returnVal = "19th"
            break;
        }
        case 20: {
            returnVal = "20th"
            break;
        }
        case 21: {
            returnVal = "21st"
            break;
        }
        case 22: {
            returnVal = "22nd"
            break;
        }
        case 23: {
            returnVal = "23rd"
            break;
        }
        case 24: {
            returnVal = "24th"
            break;
        }
        case 25: {
            returnVal = "25th"
            break;
        }
        case 26: {
            returnVal = "26th"
            break;
        }
        case 27: {
            returnVal = "27th"
            break;
        }
        case 28: {
            returnVal = "28th"
            break;
        }
        case -1: {
            returnVal = "Last day of the month"
            break;
        }
        
    }
    return returnVal;
}